import { formatName } from '@silbo/core';
import { Outlet, useRouter } from '@tanstack/react-router';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import OnClickModal from '../../../components/OnClickDialog';
import { useAuthenticationContext } from '../../../contexts/AuthenticationContext';
import { useBandwidthContext } from '../../../contexts/BandwidthContext';
import { useConfigContext } from '../../../contexts/ConfigContext/useConfigContext';
import { PortersProvider } from '../contexts/PortersProvider';
import useBreak from '../hooks/useBreak';
import { useCurrentPorter } from '../hooks/useCurrentPorter';
import Header from './Header';
import LogoutConfirmDialog from './LogoutConfirmDialog';
import OnBreakDialog from './OnBreakDialog';

const PatientTransportContent = () => {
  const { logout } = useAuthenticationContext();
  const { config } = useConfigContext();
  const { status } = useBandwidthContext();
  const porter = useCurrentPorter();

  const { invalidate } = useRouter();
  const { isOnBreak, takeBreak, leaveBreak } = useBreak();
  const [isClicked, setIsClicked] = useState(false);
  const [logoutConfirmDialogOpen, setLogoutConfirmDialogOpen] = useState(false);

  const isUnstableConnection = status !== 'online';

  const handleTakeBreak = () => {
    if (isUnstableConnection) {
      setIsClicked(true);
      return;
    }
    takeBreak();
  };

  const handleLeaveBreak = () => {
    if (isUnstableConnection) {
      setIsClicked(true);
      return;
    }
    leaveBreak();
  };

  const handleLogout = async () => {
    if (isUnstableConnection) {
      setIsClicked(true);
      return;
    }
    await logout();
    await invalidate();
  };

  const handleClose = () => {
    setIsClicked(false);
  };

  const { t } = useTranslation();

  return (
    <>
      <Header
        name={porter ? formatName(porter.firstName, porter.lastName) : ''}
        onLogout={() => setLogoutConfirmDialogOpen(true)}
        onTakeBreak={handleTakeBreak}
        autoDispatchEnabled={config?.autoDispatchEnabled || false}
      />
      <OnBreakDialog open={isOnBreak} onConfirm={handleLeaveBreak} />
      <LogoutConfirmDialog
        open={logoutConfirmDialogOpen}
        onClose={() => setLogoutConfirmDialogOpen(false)}
        onCancel={() => setLogoutConfirmDialogOpen(false)}
        onConfirm={handleLogout}
      />
      <OnClickModal
        isClicked={isClicked}
        type={'error'}
        message={t('errors.unstableConnection')}
        handleClose={handleClose}
      />
      <Outlet />
    </>
  );
};

const PatientTransportLayout = () => (
  <PortersProvider>
    <PatientTransportContent />
  </PortersProvider>
);

export default PatientTransportLayout;
